<template>
  <span class="OrderLink">
    (please see <router-link to="/products/order">How to Order</router-link>
    section for further information on specimen requirements)
    <!-- (please see How to Order section for further information on specimen requirements) -->
  </span>
</template>

<script>
export default {
  name: "OrderLink",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
};
</script>

<style lang='scss'>
.OrderLink a {
  /* color: #42b983; */
  text-decoration: none;
  text-indent: initial;
}
.OrderLink a:hover {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/global/OrderLink.vue